module.exports = __webpack_public_path__ + "img/ss.76b18ab9.svg";